import { render, staticRenderFns } from "./InvalidVariableSalaryModal.vue?vue&type=template&id=40835471&"
import script from "./InvalidVariableSalaryModal.vue?vue&type=script&lang=ts&"
export * from "./InvalidVariableSalaryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports